import { FC, useCallback, useMemo } from 'react';
import {
  CenterContent,
  CenterContentControls,
  CenteredScreenLayout,
  EmptyCenterLeft,
  EmptyCenterRight,
  EmptyFooter,
  EmptyHeader,
  StructuredText,
} from '../../Components/CenteredScreenLayout';
import styled from 'styled-components';
import {
  RemoteProcedureCall,
  useApplicationStateLoader,
  useApplicationStateValue,
} from '@resistdesign/voltra/app/utils';
import { APP_ENV_CONFIG } from '../../config';
import { PROFILE } from '../Profile/IDs';
import { Profile } from '../../../common/Types';
import { DEFAULT_POSITION_ID } from '../../../common/Positions/Constants';
import { getPurposePreface } from './PurposePreface/Utils';

const {
  api: { domain: API_DOMAIN },
} = APP_ENV_CONFIG;

const PurposeCenteredScreenLayout = styled(CenteredScreenLayout).attrs<{ className: string }>({
  className: 'purpose-centered-screen-layout',
})`
  @media screen and (max-width: 768px) {
    &.purpose-centered-screen-layout {
      grid-template-columns: 1fr 80% 1fr;
    }
  }
`;

const ScrollableStructuredText = styled(StructuredText)`
  @media screen and (max-width: 768px) {
    overflow-y: scroll;
    max-height: 70dvh;
  }
`;

export type PurposePrefaceProps = {
  authorization: string;
};

export const PurposePreface: FC<PurposePrefaceProps> = ({ authorization }) => {
  const profileRPC = useMemo<RemoteProcedureCall>(
    () => ({
      serviceConfig: {
        protocol: 'https',
        domain: API_DOMAIN,
        basePath: '/user/profile',
        authorization,
      },
      path: '/read',
    }),
    [authorization]
  );
  const { loading } = useApplicationStateLoader({
    identifier: PROFILE.READ,
    remoteProcedureCall: profileRPC,
  });
  const { value: profile = {} } = useApplicationStateValue(PROFILE.READ);
  const purposeTest = useMemo<string>(() => {
    const { positionID = DEFAULT_POSITION_ID } = profile as Profile;

    return getPurposePreface(positionID);
  }, [profile]);
  const onStartInterview = useCallback(async () => {
    history.pushState({}, '', '/interview/start');
  }, []);

  return (
    <PurposeCenteredScreenLayout>
      <EmptyHeader />
      <EmptyCenterLeft />
      <CenterContent>
        <strong>Purpose:</strong>
        <br />
        <br />
        <ScrollableStructuredText>{loading ? 'Loading...' : purposeTest}</ScrollableStructuredText>
        <br />
        <CenterContentControls>
          <button onClick={onStartInterview}>Next</button>
        </CenterContentControls>
      </CenterContent>
      <EmptyCenterRight />
      <EmptyFooter />
    </PurposeCenteredScreenLayout>
  );
};
